import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormInputComponent, SharedModule, StringCustomFieldConfig } from '@vendure/admin-ui/core';

@Component({
  selector: 'readonly-textarea-form',
  template: `
    <textarea
        [formControl]="formControl"
        [attr.readonly]="true"
        rows="5"
    >
    </textarea>
  `,
  standalone: true,
  imports: [SharedModule],
})
export class ReadonlyTextareaFormInputComponent implements FormInputComponent<StringCustomFieldConfig> {
  readonly: boolean;
  formControl: FormControl;
  config: StringCustomFieldConfig;
}